import React from "react";
import { Logo } from "@/components/Logo";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-navy-deep text-white/80 afha-grain" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <img src="/afha-logo.png" alt="AFHA" className="h-12 w-auto bg-white rounded-md p-1" />
          </div>
          <p className="text-sm leading-relaxed text-white/70 max-w-sm">
            AFHA — American Family Health Association. A national marketing organization
            bringing GeneID advanced genetic testing to more families.
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-white font-display text-lg mb-4">Organization</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/#mission" className="hover:text-white transition-colors">Our Mission</Link></li>
            <li><Link to="/#about-geneid" className="hover:text-white transition-colors">About GeneID</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="text-white font-display text-lg mb-4">GeneID Tests</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/tests/preventest" className="hover:text-white transition-colors">PrevenTest</Link></li>
            <li><Link to="/tests/newborngeneid" className="hover:text-white transition-colors">NewbornGeneID</Link></li>
            <li><Link to="/tests/prostategeneid" className="hover:text-white transition-colors">ProstateGeneID</Link></li>
            <li><Link to="/tests/tumor-testing" className="hover:text-white transition-colors">Tumor Testing</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-white/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} AFHA. All rights reserved.</span>
          <span>National marketing organization for GeneID.</span>
        </div>
      </div>
    </footer>
  );
}
